// import moment from 'moment'

export default {
  getBrands (VueApp, callback) {
    VueApp.$store.commit('brands/setLoading', true)
    VueApp.$sdk.get('/brand', {
      order: VueApp.$store.state.brands.order,
      orderAsc: VueApp.$store.state.brands.orderAsc
    }, res => {
      VueApp.$store.commit('brands/setLoading', false)
      if (!res.error && res.length) {
        VueApp.$store.commit('brands/setList', res)
      }
      callback(res)
    })
  },
  getWebforms (VueApp, callback) {
    VueApp.$sdk.get('/geofences', {}, res => {
      // if (!res.error && res.length) {
      //   VueApp.$store.commit('brands/setList', res)
      // }
      callback(res)
    })
  },
  getExtraData (VueApp, id, callback) {
    VueApp.$sdk.get('/brand/' + id + '/props', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  getServices (VueApp, id, callback) {
    VueApp.$sdk.get('/brand/' + id + '/services', {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  },
  addBrand (VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken
    VueApp.$sdk.post('/brand/', data, res => {
      callback(res)
    })
  },
  updateBrand (VueApp, data, callback) {
    data.token = VueApp.$store.state.session.sessionToken
    VueApp.$sdk.post('/brand/' + data.id, data, res => {
      callback(res)
    })
  },
  updateService (VueApp, data, callback) {
    VueApp.$sdk.post('/brand/' + data.id + '/services', {
      token: VueApp.$store.state.session.sessionToken,
      services: data.services
    }, res => {
      callback(res)
    })
  },
  updateProps (VueApp, data, callback) {
    VueApp.$sdk.post('/brand/' + data.id + '/props', {
      token: VueApp.$store.state.session.sessionToken,
      props: data.props
    }, res => {
      callback(res)
    })
  },
  deleteBrand (VueApp, id, callback) {
    VueApp.$sdk.delete('/brand/' + id, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/brands/index.js